module.exports = __webpack_public_path__ + "img/ic-google.f44752e5.svg";